export const INSERT_ADMINISTRATIVE_PANEL_DATA = 'INSERT_ADMINISTRATIVE_PANEL_DATA'
export const GET_QUEUES = 'GET_QUEUES'
